import {
  Box,
  buildPath,
  buildTemplatePath,
  Page,
  PageRoute,
  Stack,
  useElementBreakpoints,
  useValidationErrors,
  Typography,
} from "@compass/core";
import {
  Export,
  SurveyReportViewResource,
  Survey,
  SurveyReportResponse,
  SurveyReportRequest,
} from "generated/openApi";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { SurveyReportReportFilter } from "./SurveyReportReportFilter";
import { SurveyReportReportHeader } from "./SurveyReportReportHeader";
import { SurveyReportReportResult } from "./SurveyReportReportResult";
import { SurveyReportReportResultFilter } from "./SurveyReportReportResultFilter";

const routeName = "surveyReportData";

export const surveyReportReportPageRoute: PageRoute = {
  handle: "Survey Report Data",
  templatePath: buildTemplatePath(routeName),
  getPath: () => buildPath(routeName),
};

export const SurveyReportReportPage = () => {
  const { breakpointsRef, setBreakpoints, largeFieldBreakpoints } = useElementBreakpoints();
  const [screen, setScreen] = useState<"config" | "grid">("config");
  const [_export, setExport] = useState<Export>({} as Export);
  const [selectedSurveyReport, setSelectedSurveyReport] = useState<Survey | undefined>();
  const [viewResource, setViewResource] = useState<SurveyReportViewResource>();
  const [surveyReportRequest, setSurveyReportRequest] = useState<SurveyReportRequest>();
  const { validationErrors, setValidationErrors } = useValidationErrors();
  const [surveyReportData, setSurveyReportData] = useState<SurveyReportResponse>();

  useEffect(() => {
    ApiService.surveyReports.getViewResource().then((response) => {
      setViewResource(response);
    })
  }, []);

  useEffect(() => {
    if (selectedSurveyReport) {
      setSurveyReportRequest({
        surveyReportId: selectedSurveyReport!.id,
        regionIds: [],
        districtIds: [],
        schoolIds: [],
        gradeLevelIds: []
      })
    }
  }, [selectedSurveyReport]);


  return (
    <Page
      header={
        <SurveyReportReportHeader
          handle={surveyReportReportPageRoute.handle}
          _export={_export}
          setSurveyReportData={setSurveyReportData}
          surveyReportRequest={surveyReportRequest}
          screen={screen}
          setScreen={setScreen}
          setValidationErrors={setValidationErrors}
        />
      }
    >
      <Box ref={breakpointsRef}>
        {screen === "config" && (
          <Stack spacing="lg">

            <SurveyReportReportFilter
              viewResource={viewResource}
              selectedSurveyReport={selectedSurveyReport}
              setSelectedSurveyReport={setSelectedSurveyReport}
            />

          </Stack>
        )}

        {screen === "grid" && surveyReportData && (
          <Stack spacing="lg">
            {surveyReportData?.errors?.length! > 0 && (
              <>
                {
                  surveyReportData.errors!.map((error, index) => (
                    <Box key={index}>
                      <Typography color="error">{error.message}</Typography>
                    </Box>
                  ))
                }
              </>
            )}
            {surveyReportData.questions && (
              <>
                {viewResource && (
                  <SurveyReportReportResultFilter
                    viewResource={viewResource}
                    surveyReportResult={surveyReportData!}
                    surveyReportRequest={surveyReportRequest}
                    setSurveyReportRequest={setSurveyReportRequest}
                  />
                )}
                <SurveyReportReportResult
                  surveyReportResult={surveyReportData!}
                />
              </>
            )}
          </Stack>
        )}
      </Box>
    </Page>
  );
};
